import { Action, combineReducers } from "redux";
import * as store from "../../../framework/customStore";
import { TDefaultListFilter } from "../../common/defaultListFilter";
import { IAppReportPage } from "source/models/appReport/appReportPage";

// State
export interface IAppReportPageState {
    dataId: number;
    appReportPage: IAppReportPage;
}

export interface IAppReportListState {
    defaultFilter: TDefaultListFilter;
}

export interface IAppReportState {
    page: IAppReportPageState;
    list: IAppReportListState;
}

// Action type constants
const APP_REPORT_SUCCESS = "APP_REPORT_SUCCESS";
const APP_REPORT_FAILURE = "APP_REPORT_FAILURE";

const APP_REPORT_SUCCESS_LIST_SET_DEFAULT_FILTER = "APP_REPORT_SUCCESS_LIST_SET_DEFAULT_FILTER";

type T_APP_REPORT_SUCCESS = typeof APP_REPORT_SUCCESS;
type T_APP_REPORT_FAILURE = typeof APP_REPORT_FAILURE;

type T_APP_REPORT_SUCCESS_LIST_SET_DEFAULT_FILTER = typeof APP_REPORT_SUCCESS_LIST_SET_DEFAULT_FILTER;

// Action types
interface IAppReportSuccess extends Action {
    type: T_APP_REPORT_SUCCESS;
    appReportPage: IAppReportPage;
}

interface IAppReportFailure extends Action {
    type: T_APP_REPORT_FAILURE;
}

interface IAppReportListSetDefaultFilter extends Action {
    type: T_APP_REPORT_SUCCESS_LIST_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultListFilter;
}

export type AppReportAction =
    | IAppReportSuccess
    | IAppReportFailure
    | IAppReportListSetDefaultFilter;

//Actions
export const appReportSuccess = (appReportPage: IAppReportPage): IAppReportSuccess => ({
    type: APP_REPORT_SUCCESS,
    appReportPage
});

export const appReportFailure = (): IAppReportFailure => ({
    type: APP_REPORT_FAILURE
});

export const appReportListSetDefaultFilter = (defaultFilter: TDefaultListFilter): IAppReportListSetDefaultFilter => ({
    type: APP_REPORT_SUCCESS_LIST_SET_DEFAULT_FILTER,
    defaultFilter
});

//Reducers
export const appReportInitialState: IAppReportState = {
    page: {
        dataId: 0,
        appReportPage: null
    },
    list: {
        defaultFilter: null
    }
};

const page = (state: IAppReportPageState = null, action: AppReportAction) => {
    switch (action.type) {
    case APP_REPORT_SUCCESS: {
        const appReportSuccess = action as IAppReportSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            appReportPage: appReportSuccess.appReportPage
        };
    }
    case APP_REPORT_FAILURE:
        return { ...state };
    }
    return state;
};

const list = (state: IAppReportListState = null, action: AppReportAction) => {
    switch (action.type) {
    case APP_REPORT_SUCCESS_LIST_SET_DEFAULT_FILTER: {
        const listDefaultFilter = action as IAppReportListSetDefaultFilter;
        return {
            ...state,
            defaultFilter: listDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

//Root reducer
export const appReportReducer = combineReducers({
    page,
    list
});

//Utils
export const setAppReportListDefaultFilter = (defaultFilter: TDefaultListFilter) => {
    store.customStore.dispatch(appReportListSetDefaultFilter(defaultFilter));
};